import gsap from 'gsap'
import { CustomEase } from 'gsap/CustomEase'

// 註冊 GSAP 外掛並建立專屬的 CustomEase 貝茲曲線
gsap.registerPlugin(CustomEase)
CustomEase.create('clone', '0.23, 1, 0.32, 1')

/**
 * 動畫時長設定 (單位：秒)
 */
export const DURATION = Object.freeze({
    snap: 0.1, // 近乎瞬間 (例如 opacity set / 狀態歸位)
    fadeOut: 0.3,
    text: 0.4, // Loader 逐行文字
    reveal: 1.2, // 逐行 SplitText 揭露進場 (比照 Reverse-Engineering About 頁 line-mask)
    conceal: 0.7, // 逐行 SplitText 隱藏離場
    spread: 0.7, // Reorder 項目拉開 / Loader 淡出
    move: 0.9, // Reorder 項目位移 / 旋轉 / 形變
    color: 1.0, // 方塊顏色切換 / Hover 降低明度 (Dim)
    underline: 0.8, // Hover 底線畫進與抹除
    bg: 1.5 // 背景全頁換色
})

/**
 * 動畫緩動曲線設定 (Ease Curves)
 */
export const EASE = Object.freeze({
    out: 'expo.out', // 通用揭露/進場 (曲線最戲劇化，只用於大範圍內容進場)
    in: 'power2.out', // 通用離場 (改用輕量 easeOut：離場要立即反應，不套用 ease-in 式的遲緩起手)
    move: 'power2.inOut', // 平滑位移與過渡
    spread: 'power3.out', // 展示擴展/拉開
    hover: 'power4.out', // Hover / 主動狀態切換的色彩過渡 (介於 spread 與 out 之間，避免小範圍互動被套上進場等級的戲劇曲線)
    underline: 'clone', // 經典 CustomEase 曲線
    reveal: 'clone', // 逐行文字揭露 (與底線共用相同曲線)
    conceal: 'power3.out' // 逐行文字離場 (獨立設定，不與通用 EASE.in 混用；離場一律不用 ease-in，改用俐落的 easeOut)
})

/**
 * 階梯式交錯時間設定 (Stagger Delays)
 */
export const STAGGER = Object.freeze({
    none: 0,
    tight: 0.04, // 緊湊的文字或列表 Stagger
    loose: 0.3 // 較為鬆散的圖卡 Stagger
})

/**
 * 延遲時間設定 (Delays)
 */
export const DELAY = Object.freeze({
    text: 0.3
})
